import React from "react"
import "./styles.css"
import { green500 } from "material-ui/styles/colors"
import { CircularProgress } from "material-ui"
import * as api from "../../../api"
import ToolTip from "react-portal-tooltip"
import strings from "../../../localization/strings"
import { IJobInfo } from "../../../models"
import { IBigCalendarEvent } from "./ClientJobCalendarView"
interface IProps {
	event: IBigCalendarEvent
}
interface IState {
	open: boolean,
	jobInfo: IJobInfo
}

export default class MonthEvent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false,
			jobInfo: null
		}
	}

	getJobInfo(jobId: string) {
		if (this.props.event.previouslyFetchedJobId === undefined || (this.props.event.previouslyFetchedJobId && this.props.event.previouslyFetchedJobId !== jobId)) {
			this.props.event.setPreviouslyFetchedJobId(jobId)
			api.getJobInfo(jobId).then(res => {
				this.props.event.setJobInfo(res.data)
				this.setState({ jobInfo: res.data })
			})
		}
		else {
			this.setState({ jobInfo: this.props.event.jobInfo })
		}
	}

	render() {
		return (
			<div
				id={`job-${this.props.event.elId}`}
				className="Job-Event"
				style={{ background: green500 }}
				onMouseOver={() => {
					!this.state.jobInfo &&
						this.getJobInfo(this.props.event.jobId)
					this.setState({ open: true })
				}}
				onMouseLeave={() =>
					this.setState({ open: false })
				}
			>
				<span className="Job-EventTime TextOverflow">{this.props.event.jobName}</span>
				<ToolTip active={this.state.open} position="top" arrow="center" parent={`#job-${this.props.event.elId}`}>
					<div style={{ height: 125, minWidth: 175, display: "flex", alignItems: "center", justifyContent: "center" }}>
						{!this.state.jobInfo ?
							<CircularProgress /> :
							<div style={{ padding: 3 }}>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Job_Name}: </strong>{this.state.jobInfo.JobName}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Occupations}: </strong>{this.state.jobInfo.OccupationNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Specialties}: </strong>{this.state.jobInfo.SpecialtyNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Badges}: </strong>{this.state.jobInfo.BadgeNames}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Status}: </strong>{this.state.jobInfo.Status}</p>
								<p style={{ padding: 0, margin: 0 }}><strong>{strings.Employee}: </strong>{this.state.jobInfo.EmployeeNames}</p>
							</div>
						}
					</div>
				</ToolTip>
			</div>
		)
	}
}